import { useHeaderActions } from "@circle-workflows/components/ViewWorkflowModal/Header/HeaderActions/useHeaderActions";
import { WORKFLOW_STATUS } from "@circle-react/components/SettingsApp/Workflows/constants";
import type { Action } from "../../generated/WorkflowsApi.types";
import { WorkflowToggleWithAiModal } from "../DynamicWorkflowForm/WorkflowToggleWithAiModal";

interface Workflow {
  id: string;
  status: string;
  steps?: Action["action_type"][];
}

interface ActiveToggleProps {
  workflow: Workflow;
}

export const ActiveToggle = ({ workflow }: ActiveToggleProps) => {
  const { id: workflowId, status, steps } = workflow;
  const isActive = status === WORKFLOW_STATUS.ACTIVE;
  const hasActions = Boolean(steps?.length);
  const isDraft = status === WORKFLOW_STATUS.DRAFT;
  const { isLoading, onChangeActiveStatus } = useHeaderActions({
    workflowId,
    isActive,
  });

  return (
    <WorkflowToggleWithAiModal
      isActive={isActive}
      onToggle={onChangeActiveStatus}
      steps={steps}
      workflowId={workflowId}
      isDisabled={!hasActions || isDraft}
      hasNoActions={!hasActions}
      isDraft={isDraft}
      isLoading={isLoading}
    />
  );
};
